import { component } from 'picoapp';
import jump from 'jump.js';
import { gsap } from 'gsap';
import { str2json, getClosest } from '@utils';
import './Accordion.scss'

class Accordion {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.timelines = [];
    this.options = str2json(el.dataset.options);
    this.init(el);
  }

  init(el) {
    this.el = el;
    this.items = el.querySelectorAll('.Accordion__item');
    this.initAnimations();
  }

  initAnimations() {
    
    this.items.forEach(item => {
      const content = item.querySelector('.Accordion__content');
      const tl = gsap.timeline({
        paused: true,
        onStart: () => {
          item.classList.add('is-active');
          
        },
        onComplete: () =>{
          if (this.options.jump) {
            setTimeout(() => {
              jump(item, {
                duration: 100,
                offset: -100
              })    
            }, 300);
          }
        },
        onReverseComplete: () => {
          item.classList.remove('is-active');
        },
      })

      tl.set(content, {clearProps: 'all'});
      tl.to(content, { height: "auto", opacity: 1, duration: 0.3, ease: 'power.out' });
      
      this.timelines.push(tl);
    });
    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach((item, index) => {
      item.querySelector('.Accordion__toggle').addEventListener('click', (e) => {
        if (e.target.classList.contains('Accordion__toggle') || getClosest(e.target, '.Accordion__toggle')) {
          e.preventDefault();
          
          this.toggle(item.dataset.item);
        }
      })

      //Keyboard navigation
      item.querySelector('.Accordion__toggle').addEventListener('keyup', (e) => {  
        if (e.target.classList.contains('Accordion__toggle') || getClosest(e.target, '.Accordion__toggle')) {
          switch (e.key) {
            case 'Enter':
              e.preventDefault(); 
              this.toggle(item.dataset.item);
              
              break;
            case 'ArrowUp':
              if(index > 0){
                e.preventDefault(); 
                this.items[index-1].querySelector('.Accordion__toggle').focus();  
              }
              break;
            case 'ArrowDown':
              if( index < this.items.length - 1 ){
                e.preventDefault(); 
                this.items[index+1].querySelector('.Accordion__toggle').focus();  
              }
              break;
            default:
              break;
          }
        }
      })
    })
  }

  toggle(index){
    this.timelines.forEach((tl,idx) => {
      if (idx == index) {
        if( tl.progress() == 1){
          tl.reverse()
        }  else {
          tl.play();

        }
      } else {
        tl.reverse();
      }
    })
  }
}

export default component((node, ctx) => {
  new Accordion(node, ctx);
});
